// Meta Pixel ID
const PIXEL_ID = '741445578526747'

// Extend window type for fbq
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: unknown
  }
}

// Initialize and inject the Meta Pixel script
export function initMetaPixel(): void {
  if (typeof window === 'undefined') return
  if (window.fbq) return // already initialized

  // Inject the fbevents.js script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // Bootstrap fbq queue
  const fbq = function (...args: unknown[]) {
    if (
      (fbq as unknown as { callMethod: (...a: unknown[]) => void }).callMethod
    ) {
      ;(fbq as unknown as { callMethod: (...a: unknown[]) => void }).callMethod(
        ...args,
      )
    } else {
      ;(fbq as unknown as { queue: unknown[][] }).queue.push(args)
    }
  } as unknown as Window['fbq'] & {
    loaded: boolean
    version: string
    queue: unknown[][]
    callMethod?: (...a: unknown[]) => void
  }

  if (!window._fbq) window._fbq = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []
  window.fbq = fbq

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

// Fire AddToCart event
export function trackAddToCart(): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'AddToCart')
}
